import { MutationResolvers } from '@spazious/dollhouse-graphql';
import {
  CreateBookingPlannerRfpRequestDataAttributesAccountTypeEnum as AccountTypeEnum,
  CreateBookingPlannerRfpRequestDataAttributesSegmentationTypeEnum as SegmentationTypeEnum,
} from '@spazious/react-booking-engine';

import { ApolloContext } from '../context.js';
import { getFurnitureStats } from '../helpers/index.js';

/**
 * Resolver for the createProposal mutation.
 */
export const createProposal: MutationResolvers<ApolloContext>['createProposal'] = async (
  _,
  { input, graph: graphInput },
  context
) => {
  const { api } = context;
  const {
    accountType,
    accountName,
    attendees,
    description,
    email,
    segmentationType,
    endDate,
    phoneNumber,
    startDate,
    hotelId,
  } = input;

  const result = await api.booking.createBookingPlannerRfp({
    createBookingPlannerRfpRequest: {
      data: {
        type: 'GenericOrder',
        attributes: {
          accountType: accountType as AccountTypeEnum,
          accountName,
          attendees,
          description,
          email,
          segmentationType: segmentationType as SegmentationTypeEnum,
          graph: JSON.stringify(graphInput),
          name: graphInput?.name,
          phoneNumber,
          furnitures: getFurnitureStats(context.graph),
          endDate: endDate?.toISOString().substring(0, 10),
          startDate: startDate.toISOString().substring(0, 10),
        },
        relationships: {
          virtualMeetingRoom: {
            data: {
              type: 'VirtualMeetingRoom',
              id: graphInput.space,
            },
          },
          hotel: {
            data: {
              type: 'Hotel',
              id: hotelId,
            },
          },
        },
      },
    },
  });

  const data = result.data.data;
  return {
    id: data.attributes?.uuid!,
    accountName: accountName,
    accountType: accountType,
    description: description,
    email: email,
    phoneNumber: phoneNumber,
    endDate: data.attributes?.endDate!,
    attendees: data.attributes?.attendees!,
    startDate: data.attributes?.startDate!,
    segmentationType: data.attributes?.segmentationType!,
    hotelId: hotelId,
    graph: {
      id: (data as any).meta.virtualMeetingRoomSetup,
      ...graphInput,
    },
  };
};
